export enum FunnelCategoryEnum {
  SALES = "SALES",
  SUPPORT = "SUPPORT",
  ONBOARDING = "ONBOARDING",
  OTHER = "OTHER"
}
